var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dk-open-video"},[_c('a',{staticClass:"dk-open-video__toggler",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showVideoModal.apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }